import { render, staticRenderFns } from "./CancelLabelButton.vue?vue&type=template&id=9aee55cc&"
import script from "./CancelLabelButton.vue?vue&type=script&lang=js&"
export * from "./CancelLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports